import Utils from '../../modules/utils'

const getCustomAccessData = (userId, callbackFunc) => {
  const url = 'custom_access/' + userId
  Utils.get(url, callbackFunc)
}

export {getCustomAccessData}
